import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      y: "0.277344",
      width: "14",
      height: "14",
      rx: "7",
      fill: "#4A4A4A"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.61433 8.9003H6.50677L6.4629 8.22041C6.36421 6.53166 8.18456 6.3562 8.18456 5.21574C8.18456 4.68938 7.80075 4.25074 7.05507 4.25074C6.34228 4.25074 5.83785 4.65648 5.45404 5.40216L4.5 4.73324C4.93864 3.71341 5.84881 3.05545 7.12086 3.05545C8.6232 3.05545 9.50047 3.93273 9.50047 5.13898C9.50047 6.8716 7.72399 6.91546 7.64723 8.15462L7.61433 8.9003ZM7.80075 11.4992H6.32035V10.0188H7.80075V11.4992Z",
      fill: "#D4D4D4"
    }, null, -1)
  ]))]))
}
export default { render: render }